import './scripts/main';
import './scripts/forms';
import { createSwiper, setupCardDeckSwiperForMobile } from './scripts/swipers';
import { isTablet, setupResponsiveCallback } from './scripts/utils';
import { setupFaqBlock, resetFaqBlock } from './scripts/faq_block';

let engagementSwiper = null;

function setupEngagementContainer(e) {
  const $container = $('#engagement-swiper');
  const $wrapper = $('#engagement-swiper-wrapper');

  resetFaqBlock($container);

  $container.toggleClass('swiper-container', isTablet());
  $wrapper.toggleClass('swiper-wrapper', isTablet());
  $container.find('.engagement-item').toggleClass('swiper-slide', isTablet());

  const shouldUseSwiper = isTablet() || (e.type === 'orientationchange' && window.orientation === 0);

  if (shouldUseSwiper) {
    if (!engagementSwiper) {
      engagementSwiper = createSwiper('#engagement-swiper');
    }
  } else {
    if (engagementSwiper !== null) {
      engagementSwiper.destroy();
      engagementSwiper = null;
    }
    setupFaqBlock('#engagement-swiper');
  }
}

setupResponsiveCallback(setupEngagementContainer);

setupCardDeckSwiperForMobile('#cases-swiper');
